import { usePrivilegeAccessControl } from '@/hooks/usePrivilegeAccessControl';

/** Accounts with this privilege fetch no quotes and see no prices when creating or scaling clusters and backups. */
export const HIDE_BILLING_QUOTES = 'HIDE_BILLING_QUOTES';

export function useIsBillingQuotesHidden(): boolean {
  return usePrivilegeAccessControl([HIDE_BILLING_QUOTES]).matches;
}
